import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SchoolGroup } from '@core/models/domain/group.domain';

export interface MoveToGroupDialogData {
  pupilName: string;
  /** The school's ACTIVE groups; only these reach the pupil with school restrictions. */
  groups: SchoolGroup[];
}

/**
 * Picks the active group a pupil left in no active group should join (DIGI-1701). Closes with the
 * chosen group id, or with nothing on cancel.
 */
@Component({
  selector: 'app-move-to-group-dialog',
  templateUrl: './move-to-group-dialog.component.html',
  styleUrl: './move-to-group-dialog.component.scss',
  standalone: false,
})
export class MoveToGroupDialogComponent {
  selectedGroupId: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<MoveToGroupDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) public data: MoveToGroupDialogData
  ) {}

  get groups(): SchoolGroup[] {
    return [...(this.data.groups ?? [])].sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
  }

  confirm(): void {
    if (this.selectedGroupId) {
      this.dialogRef.close(this.selectedGroupId);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
